import * as React from 'react';
import { CalendarHeader } from './CalendarHeader.js';
import { CalendarLabel } from './CalendarLabel.js';
import { MonthYearButton } from './MonthYearButton.js';
import { MonthYearContainer } from './MonthYearContainer.js';
import { useYearPicker } from './useYearPicker.js';

var YearPicker = function YearPicker(props) {
  var containerGridRef = props.containerGridRef;
  var _useYearPicker = useYearPicker(props),
    calendarHeaderProps = _useYearPicker.calendarHeaderProps,
    getButtonCellProps = _useYearPicker.getButtonCellProps,
    yearRange = _useYearPicker.yearRange;
  return /*#__PURE__*/React.createElement(MonthYearContainer, {
    testId: "year-picker",
    containerGridRef: containerGridRef,
    header: /*#__PURE__*/React.createElement(CalendarHeader, calendarHeaderProps, /*#__PURE__*/React.createElement(CalendarLabel, {
      label: "".concat(yearRange[0], " - ").concat(yearRange[yearRange.length - 1])
    })),
    buttonCell: function buttonCell(count) {
      return /*#__PURE__*/React.createElement(MonthYearButton, getButtonCellProps(count));
    }
  });
};

export { YearPicker };
//# sourceMappingURL=YearPicker.js.map
